module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('div', {
    staticClass: "px-2 py-3"
  }, [_c('app-header', {
    staticClass: "text-white",
    attrs: {
      "icon": "factory"
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl font-semibold tracking-wide"
  }, [_vm._v("Installations")])])]), _vm._v(" "), _c('action-bar', {
    attrs: {
      "back": {
        name: 'liste-detenteurs'
      }
    }
  }, [_c('a', {
    staticClass: "bg-white transition px-4 py-2 rounded-lg text-primary text-sm font-medium",
    attrs: {
      "id": "main-action"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addInstallation($event)
      }
    }
  }, [_vm._v("\n                    Ajouter\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "pb-4"
  }, [_c('filter-bar', {
    attrs: {
      "gotFilter": true,
      "filterText": "Installation avec fluide",
      "placeholderFilter": "Rechercher par Nom",
      "type-history": "installation"
    },
    on: {
      "searchBarChanged": _vm.updateSearch,
      "filterValChanged": _vm.changeList
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "px-4 py-2 rounded-lg text-md flex items-center justify-center gap-2 mb-5",
    class: _vm.listVisible === 'fluide' ?
      'bg-vert text-white' :
      'bg-gray-300 text-gray-800',
    attrs: {
      "id": "btnFilterActive"
    },
    on: {
      "click": _vm.toggleList
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-snow",
    class: _vm.listVisible === 'fluide' ? 'bg-white' : 'bg-gray-800'
  }), _vm._v(" "), _c('span', [_vm._v("\n                    " + _vm._s(_vm.listVisible === 'fluide' ? 'Avec fluide' : 'Sans fluide') + "\n                ")])])], 1)]), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listVisible === 'fluide'),
      expression: "listVisible === 'fluide'"
    }],
    staticClass: "mx-1 my-2 shadow-2xl rounded-lg overflow-hidden bg-white"
  }, _vm._l((_vm.filterListFluide), function(installation) {
    return _c('installation-item', {
      key: installation.id,
      attrs: {
        "installation": installation
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listVisible === 'noFluide'),
      expression: "listVisible === 'noFluide'"
    }],
    staticClass: "mx-1 my-2 shadow-2xl rounded-lg overflow-hidden bg-white"
  }, _vm._l((_vm.filterListNoFluide), function(installation) {
    return _c('installation-item', {
      key: installation.id,
      attrs: {
        "installation": installation
      }
    })
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e394e714","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/installation/ListeInstallations.vue
// module id = 1057
// module chunks = 0